import { __assign, __decorate, __extends, __metadata } from "tslib";
import * as React from 'react';
import { BindPropsHelper } from './PropTypes';
import { Components, Utils } from '@singularsystems/neo-core';
import { InputHelpers } from './InputHelpers';
import { observer } from 'mobx-react';
import ComponentBase from './ComponentBase';
import { FormContext } from './FormContext';
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.isReadOnly = false;
        _this.inputRef = React.createRef();
        _this.container = React.createRef();
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        if (this.container.current) {
            this.datePicker = new Components.DatePicker(this.container.current, this.props.dateProps);
            this.datePicker.update(this.props.dateProps, this.props.bind, this.isReadOnly);
        }
    };
    DatePicker.prototype.componentWillUnmount = function () {
        if (this.datePicker) {
            this.datePicker.destroy();
            this.datePicker = undefined;
        }
    };
    DatePicker.prototype.render = function () {
        var splitProps = BindPropsHelper.normaliseEditorProps(this, this.props);
        var domProps = BindPropsHelper.autoSetDomProperties(splitProps, this.context);
        domProps.className = Utils.joinWithSpaces(domProps.className, splitProps.isBootstrap ? "form-control" : "neo-forms-editor");
        this.isReadOnly = !!domProps.readOnly;
        var displayInfo = this.props.bind.validator.getDisplayState(this.context.validationDisplayMode);
        displayInfo.applyToDom(domProps, !splitProps.inGroup);
        if (splitProps.editor.inputElement) {
            this.inputRef = splitProps.editor.inputElement;
        }
        if (this.datePicker) {
            this.datePicker.update(splitProps.dateProps, this.props.bind, this.isReadOnly);
        }
        else {
            // Create dependency on bound value on initial render.
            void this.props.bind.value;
        }
        return (React.createElement("div", { className: "neo-datepicker-container", ref: this.container }, Components.DatePicker.mustShowInput(splitProps.dateProps) &&
            InputHelpers.surroundWithInputGroup(React.createElement("input", __assign({ type: "text" }, domProps, { ref: this.inputRef })), splitProps.editor, this.inputRef)));
    };
    DatePicker.contextType = FormContext;
    DatePicker = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], DatePicker);
    return DatePicker;
}(ComponentBase));
export default DatePicker;
